import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { PluginConfigComponentProps } from '../types';

export type LoyaltyConfig = {
  points_per_real: number;
  minimum_sale_value: number;
};

const schema = z.object({
  points_per_real: z.coerce
    .number({ invalid_type_error: 'Informe um número' })
    .min(0.01, 'Deve ser maior que zero'),
  minimum_sale_value: z.coerce
    .number({ invalid_type_error: 'Informe um número' })
    .min(0, 'Não pode ser negativo'),
});

export const LoyaltyConfigComponent = ({
  config,
  onSave,
  isSaving,
}: PluginConfigComponentProps<LoyaltyConfig>) => {
  const form = useForm<LoyaltyConfig>({
    resolver: zodResolver(schema),
    defaultValues: {
      points_per_real: config.points_per_real ?? 1,
      minimum_sale_value: config.minimum_sale_value ?? 0,
    },
  });

  const handleSubmit = (values: LoyaltyConfig) => {
    onSave(values);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="points_per_real"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Pontos por R$ 1,00 gasto</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.01"
                  min="0.01"
                  placeholder="1"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Quantos pontos o cliente ganha a cada R$ 1,00 em compras pagas.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="minimum_sale_value"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Valor mínimo da venda (opcional)</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="0"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Vendas com total abaixo desse valor não geram pontos. Deixe 0 para não aplicar limite.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex justify-end">
          <Button type="submit" disabled={isSaving}>
            {isSaving ? 'Salvando...' : 'Salvar configuração'}
          </Button>
        </div>
      </form>
    </Form>
  );
};
